import get from "lodash.get";
import { LandingName, LocationType, TextType } from "../types";

const getTextFromWidgetHero = (config: any, path: string) => get(config, path);

const getText = (config: any, landingName: string, location: LocationType, type: TextType) =>
  get(config, `landings.${landingName}.${location}.${type}`);

export const getMetaTitle = (config: object, landingName: string) =>
  getText(config, landingName, LocationType.Head, TextType.Title);

export const getMetaDescription = (config: object, landingName: string) =>
  getText(config, landingName, LocationType.Head, TextType.Description);

export const getTitle = (config: object, landingName: string) => {
  if (landingName === LandingName.ProductDetail) {
    return "";
  }
  return (
    getTextFromWidgetHero(config, "widgets.hero.config.title.label") ||
    getText(config, landingName, LocationType.Header, TextType.Title)
  );
};

export const getSubtitle = (config: object, landingName: string) =>
  getTextFromWidgetHero(config, "widgets.hero.config.subtitle.label") ||
  getText(config, landingName, LocationType.Header, TextType.Subtitle);

export const getEventDescription = (config: object) =>
  getTextFromWidgetHero(config, "widgets.hero.config.description.label");
